import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
}>;

export default function Label({ children, label, disabled, fullWidth }: Props) {
  const styles: CSSProperties = {
    position: "relative",
    display: "block",

    color: `var(--color-text-${disabled ? "disabled" : "primary"})`,
    fontSize: "var(--font-size-xs)",
    fontWeight: 400,

    width: fullWidth ? "100%" : "auto",
  };

  return (
    <label style={styles}>
      {label}
      {children}
    </label>
  );
}
